import { Component, HostListener, Inject, OnInit, inject, signal, computed } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CancelConfirmDialogData } from './cancel-confirm-dialog-data';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-cancel-confirm-dialog',
    templateUrl: './cancel-confirm-dialog.component.html',
    standalone: true,
    imports: [CommonModule, MatButtonModule, MatDialogModule, MatIconModule]
})
export class CancelConfirmDialogComponent implements OnInit {
    // Services using inject()
    private matDialogRef = inject(MatDialogRef<CancelConfirmDialogComponent>);

    // Signals for reactive state
    isVisible = signal(true);

    // Computed signals
    currentVisibility = computed(() => this.isVisible());

    constructor(
        @Inject(MAT_DIALOG_DATA) public cancelConfirmDialogData: CancelConfirmDialogData
    ) { }

        
    ngOnInit() {
    }

    confirm() {
        this.isVisible.set(false);
        this.close('confirm');
    }

    cancel() {
        this.isVisible.set(false);
        this.close('cancel');
    }

    close(value: any) {
        this.isVisible.set(false);
        this.matDialogRef.close(value);
    }

    @HostListener('keydown.esc')
    public onEsc() {
        this.close('ESC keydown');
    }
}
